import React, { useEffect, useRef } from "react";

// Home cover: the video fills a fixed-height band (same size as the Method banner), cropped with object-cover;
// on phones the band takes the video's 16:9 shape so the whole frame shows. Colour / black-and-white on hover like every cover.
export const HomeBanner = () => {
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    v.muted = true;
    v.play().catch(() => {});
  }, []);
  return (
    <section data-testid="home-banner" style={{ "--banner-ratio": "16 / 9" }} className="day-light-bg group relative mt-14 banner-full overflow-hidden bg-black">
      <video ref={ref} data-testid="home-banner-video" src="/media/home-video.mp4" autoPlay muted loop playsInline className="bw-hover absolute inset-0 w-full h-full object-cover" />
      {/* <div className="absolute inset-0 flex items-end pointer-events-none bg-gradient-to-t from-black/60 via-transparent to-transparent">
        <div className="w-full max-w-7xl mx-auto px-6 lg:px-12 pb-6 sm:pb-10 lg:pb-14">
          <p data-testid="home-banner-title" className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white">lighting project</p>
        </div>
      </div> */}
    </section>
  );
};
